<app-cookie-banner #cookieCmp position="bottom"></app-cookie-banner>
<app-header></app-header>
<router-outlet></router-outlet>
<!-- <app-footer></app-footer> -->